


























































































































































































































import { Component, Vue } from 'vue-property-decorator'
import controller from '@/app/ui/controllers/AuthController'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import LionParcelLogo from '@/app/ui/assets/lion_parcel_logo.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import ForgotPasswordInput from './components/ForgotPasswordInput/index.vue'
import ResetPasswordModal from './components/ResetPasswordModal/index.vue'
import ResetPasswordSuccess from '@/app/ui/assets/reset_password_success.vue'
import ForgotPasswordExpired from '@/app/ui/assets/forgot_password_expired.vue'
import { validationMixin } from 'vuelidate'
import { Validations } from 'vuelidate-property-decorators'
import { email, required } from 'vuelidate/lib/validators'
import { EventBus, EventBusConstants, Utils } from '@/app/infrastructures/misc'
import { ExchangeOTPRequest, ForgotPasswordRequest, RequestLibertaOTP } from '@/data/payload/api/AuthRequest'
import VerifyOTPModal from './components/VerifyOTPModal/index.vue'
import ForceUpdatePasswordModal from './components/ForceUpdatePasswordModal/index.vue'
import { recaptchaV3 } from '@/app/infrastructures/misc/RecaptchaV3'
import BadgeSuccess from '../../assets/badge_success.vue'
import OTPActivationModal from './components/OtpActivationModal/index.vue';
import { TwoFactorAuthLogin } from '@/domain/entities/Account'
import LoadingOverlay from '../../components/LoadingOverlay/index.vue'
import dayjs from 'dayjs'

@Component({
  mixins: [validationMixin],
  components: {
    TextInput,
    Button,
    LionParcelLogo,
    Modal,
    ForgotPasswordInput,
    ResetPasswordModal,
    ResetPasswordSuccess,
    ForgotPasswordExpired,
    VerifyOTPModal,
    ForceUpdatePasswordModal,
    BadgeSuccess,
    OTPActivationModal,
    LoadingOverlay
  },
})
class LoginPage extends Vue {
  controller = controller
  form = {
    email: '',
    password: '',
  }

  forgotPasswordModal = false
  forgotPasswordEmail = ''
  resetPasswordModal = false
  resetPasswordSuccess = false
  forgotPasswordLimit = false
  verifyOTPModal = false;
  verifyOTPModalLoading = false;
  otpErrorMessage = "";
  otpEmail = "";
  otpId = 0;
  forceUpdatePasswordModal = false;
  forceUpdatePasswordLoading = false;
  role = "";
  tokenExchange = "";
  otpActivationModal = false;
  otpActivationLoading = false;
  otpActivationTokenData = new TwoFactorAuthLogin()
  isLoading2FAOTP = false;

  created(): void {
    if (
      this.$route.query.forgot_password ||
      this.$route.query['forgot-password']
    ) {
      this.forgotPasswordModal = true
    }

    if (
      this.$route.query.reset_password ||
      this.$route.query['reset-password']
    ) {
      this.resetPasswordModal = true
    }

    EventBus.$on(EventBusConstants.FORGOT_PASSWORD_SUCCESS, () => {
      this.forgotPasswordModal = false

      this.$router.push({
        name: 'ResetPassword',
        query: {
          status: 'send',
          email: this.forgotPasswordEmail,
        },
      })
    })

    EventBus.$on(EventBusConstants.RESET_PASSWORD_SUCCESS, () => {
      this.resetPasswordModal = false
      this.resetPasswordSuccess = true
    })

    EventBus.$on(EventBusConstants.FORGOT_PASSWORD_LIMIT, () => {
      this.forgotPasswordModal = false
      this.forgotPasswordEmail = ''
      this.forgotPasswordLimit = true
    })

    EventBus.$on(EventBusConstants.REQUIRE_CHANGE_PASSWORD, (res: any) => {
      this.role = res.role_id;
      this.forceUpdatePasswordModal = true;
    })

    EventBus.$on(EventBusConstants.REQUIRE_OTP, (res: TwoFactorAuthLogin) => {
      this.otpActivationModal = true;
      this.otpActivationTokenData = res;
    })
    EventBus.$on(EventBusConstants.PROCEED_OTP_2FA, (res: TwoFactorAuthLogin) => {
      this.otpActivationTokenData = res;
      this.handleRequest2FAOTP();
    })
  }

  @Validations()
  validations(): Record<string, any> {
    return {
      forgotPasswordEmail: {
        required,
        email,
      },
    }
  }

  get loginButtonText(): string {
    if (!this.resetPasswordModal && !this.forgotPasswordModal) {
      if (this.controller.isLoading) {
        return 'Loading...'
      }

      if (this.controller.isLoadingProfile && !this.resetPasswordModal) {
        return 'Fetching Profile...'
      }
    }

    return 'Login'
  }

  private submitLogin() {
    controller.sendLogin2FA(this.form)
  }

  private async sendForgotPassword() {
    const token = await recaptchaV3.executeRecaptcha()
    controller.forgotPassword(new ForgotPasswordRequest({
      email: this.forgotPasswordEmail,
      otpType: 'PASSWORD_RESET',
      token: token
    }))
  }

  private resetPassword(password: string, passwordConfirmation: string) {
    controller.resetPassword({
      token: (this.$route.query.reset_password ||
        this.$route.query['reset-password']) as string,
      password,
      passwordConfirmation,
    })
  }

  get disabled(): boolean {
    return (
      (this.controller.isLoading || this.controller.isLoadingProfile) &&
      !this.resetPasswordModal &&
      !this.forgotPasswordModal
    )
  }

  private closeResetPasswordSuccessModal() {
    this.resetPasswordSuccess = false
    this.$router.replace({
      name: 'LoginPage',
      query: {}
    })
  }

  public async onForceUpdatePassword(): Promise<void> {
    try {
    this.forceUpdatePasswordLoading = true
    const token = await recaptchaV3.executeRecaptcha()
    const payload = new RequestLibertaOTP({
      email: this.form.email,
      otpType: "PASSWORD_RESET",
      messagingType: "EMAIL",
      role: this.role,
      token,
    })
    const resp = await controller.requestLibertaOTP(payload);
    this.verifyOTPModal = true;
    this.forceUpdatePasswordModal = false;
    this.otpEmail = Utils.maskEmail(this.form.email);
    this.otpId = resp.otpId;
    localStorage.removeItem("otp-countdown")
    await this.$nextTick()
    EventBus.$emit(EventBusConstants.RESET_VERIFY_OTP_MODAL, resp.expiredIn);
    } catch (error) {
      // error
      Vue.notify({
        title: 'Request OTP Failed',
        text: error.data.message.id,
        type: 'error',
        duration: 5000,
      })
    } finally {
      this.forceUpdatePasswordLoading = false;
    }
  }

  public async onVerifyOTP(otp = ""): Promise<void> {
    try {
      this.otpErrorMessage = "";
      this.verifyOTPModalLoading = true;
      const payload = new ExchangeOTPRequest({
        otp,
        otpId: this.otpId
      })
      const resp = await controller.exchangeOTP(payload);
      this.tokenExchange = resp;
      this.$router.replace({query: {reset_password: resp}})
      this.verifyOTPModal = false;
      this.resetPasswordModal = true;
    } catch (error) {
      this.otpErrorMessage = error.data.message.id
    } finally {
      this.verifyOTPModalLoading = false;
    }
  }

  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.FORGOT_PASSWORD_SUCCESS);
    EventBus.$off(EventBusConstants.RESET_PASSWORD_SUCCESS);
    EventBus.$off(EventBusConstants.FORGOT_PASSWORD_LIMIT);
    EventBus.$off(EventBusConstants.REQUIRE_CHANGE_PASSWORD);
    EventBus.$off(EventBusConstants.PROCEED_OTP_2FA);
    EventBus.$off(EventBusConstants.REQUIRE_OTP);
  }

  cleanPhoneNumber(phoneNumber: string) {
    return Utils.cleanPhoneNumber(phoneNumber);
  }

  async handleRequest2FAOTP() {
    try {
      this.isLoading2FAOTP = true;
      const captcha = await recaptchaV3.executeRecaptcha()

      const resp = await this.controller.request2FAOTP(
        new RequestLibertaOTP({
          email: this.form.email,
          captcha,
          challengeToken: this.otpActivationTokenData.twoFactorAuth.challengeToken
        })
      );
      localStorage.removeItem("otp-countdown")

      this.otpActivationModal = false;
      this.otpId = resp.otpId;

      let retryCountdown = new Date(
        dayjs()
          .add(resp.cooldownIn, 'seconds')
          .toISOString()
      ).getTime()

      localStorage.setItem("otp-countdown", retryCountdown.toString());

      await this.$nextTick();

      this.$router.push({
        name: 'VerifyOtp',
        query: {
          otp_id: String(resp.otpId),
          email: String(resp.username),
          token: this.otpActivationTokenData.twoFactorAuth.challengeToken,
        }
      })
    } catch (error) {
      this.$notify({
        title: 'Request OTP Failed',
        text:
          [400, 422, 401, 423].includes(error.status) ? error.error.message.id : 'Something wrong',
        type: 'error',
        duration: 5000,
      })
    } finally {
      this.isLoading2FAOTP = false;
    }
  }

  onOtpSkip() {
    this.otpActivationModal = false;
    this.controller.handleSkipOtp({
      token: this.otpActivationTokenData.authentication!,
      email: this.form.email
    });
  }
}
export default LoginPage;
